export default "__VITE_ASSET__BINaVa8$__"